// src/frontend_react/src/utils/filenameHelper.js
function getUtcTimestamp() {
  return new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15) + 'Z';
}

function sanitizeForFilename(text) {
  if (!text) return 'unknown';
  return text.toLowerCase().replace(/[^a-z0-9_.-]+/g, '-');
}

export function generateDeidentifiedFilenameForClient(projectId, batchId, sourceType) {
  const timestamp = getUtcTimestamp();
  const safeProjectId = sanitizeForFilename(projectId);
  const safeSourceType = sanitizeForFilename(sourceType);
  return `${safeProjectId}__${batchId}__DEID__${timestamp}__${safeSourceType}.csv.aes`;
}